module.exports = __webpack_public_path__ + "static/media/selcareLogo.596b4945.png";